import { Clone, useGLTF } from "@react-three/drei";
import { forwardRef } from "react";
import * as THREE from "three";

interface PillarProps {
    position: [number, number, number];
    rotation?: [number, number, number];
    scale?: number | [number, number, number];
}

const Pillar = forwardRef<THREE.Group, PillarProps>(
    ({ position, rotation = [0, 0, 0], scale = 1 }: PillarProps, ref) => {
        const { scene } = useGLTF("/models/pillar_2.glb");

        return (
            <group
                ref={ref}
                position={position}
                rotation={rotation}
                scale={scale}
            >
                <Clone object={scene} castShadow receiveShadow />
            </group>
        );
    },
);

export default Pillar;

useGLTF.preload("/models/pillar_2.glb");
